/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import {
  ACCESS_LOG_CAP,
  CITIES_CAP,
  CLEARING_ACCOUNT_REPORT_CAP,
  COMMISSIONS_CAP,
  COUNTRIES_CAP,
  DASHBOARD_CAP,
  NOTIFICATIONS_CAP,
  REFUNDS_CAP,
  REPORT_ABUSES_CAP,
  SETTINGS_CAP,
  STATES_CAP,
  SUB_ADMINS_CAP,
  TRANSACTIONS_CAP,
  TRANSACTIONS_REPORT_CAP,
  USERS_CAP
} from "../../../../../app/utils/const";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };
  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">{DASHBOARD_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(
            "/history-listing",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/history-listing">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Exchange.svg")}
              />
            </span>
            <span className="menu-text">{TRANSACTIONS_CAP}</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/commission", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/commission">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")}
              />
            </span>
            <span className="menu-text">{COMMISSIONS_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive(
            "/bank-transactions",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/bank-transactions">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/MC.svg")} />
            </span>
            <span className="menu-text">{BANK_TRANSACTIONS_CAP}</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive(
            "/bankAccount-listing",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/bankAccount-listing">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")} />
            </span>
            <span className="menu-text">{constant.BANK_ACCOUNTS_CAP}</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/user-listing", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/user-listing">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </span>
            <span className="menu-text">{USERS_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item d-none${getMenuItemActive(
            "/subAdmin-listing",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/subAdmin-listing">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")}
              />
            </span>
            <span className="menu-text">{SUB_ADMINS_CAP}</span>
          </NavLink>
        </li>
        {/*Begin:Location Dropdown Menu*/}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/location",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/location">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Marker1.svg")} />
            </span>
            <span className="menu-text">Locations</span>
            <i className="menu-arrow"></i>
          </NavLink>
          <div className="menu-submenu">
            <ul className="menu-subnav">
              {/*begin:country*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/location/country-listing",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/country-listing">
                  <i className="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span className="menu-text">{COUNTRIES_CAP}</span>
                </NavLink>
              </li>
              {/*begin:state*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "location/state-listing",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/state-listing">
                  <i className="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span className="menu-text">{STATES_CAP}</span>
                </NavLink>
              </li>
              {/*begin::City*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/city-listing",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/city-listing">
                  <i className="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span className="menu-text">{CITIES_CAP}</span>
                </NavLink>
              </li>
              {/**/}
            </ul>
          </div>
        </li>
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/reports",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/reports">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Devices/Server.svg")} />
            </span>
            <span className="menu-text">Reports and Analytics</span>
            <i className="menu-arrow"></i>
          </NavLink>
          <div className="menu-submenu">
            <ul className="menu-subnav">
              {/*begin:country*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "/reports/transactions-report",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink
                  className="menu-link"
                  to="/reports/transactions-report"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span className="menu-text">{TRANSACTIONS_REPORT_CAP}</span>
                </NavLink>
              </li>
              {/*begin:state*/}
              <li
                className={`menu-item ${getMenuItemActive(
                  "reports/clearing-account-report",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink
                  className="menu-link"
                  to="/reports/clearing-account-report"
                >
                  <i className="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span className="menu-text">
                    {CLEARING_ACCOUNT_REPORT_CAP}
                  </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}
        {/*End:Location Dropdown Menu*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/bank-listing", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/bank-listing">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Layout/Layout-top-panel-6.svg"
                )}
              />
            </span>
            <span className="menu-text">{BANK_CAP}</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/pay-vendor", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/pay-vendor">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Credit-card.svg")} />
            </span>
            <span className="menu-text">Pay a Vendor</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/refunds", false)} d-none`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/refunds">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Navigation/Arrow-from-left.svg"
                )}
              />
            </span>
            <span className="menu-text">{REFUNDS_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(
            "/notifications",
            false
          )} d-none`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/notifications">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/General/Notification2.svg"
                )}
              />
            </span>
            <span className="menu-text">{NOTIFICATIONS_CAP}</span>
          </NavLink>
        </li>{" "}
        {/*end::1 Level
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/access-log", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/access-log">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/Clipboard-list.svg"
                )}
              />
            </span>
            <span className="menu-text">{ACCESS_LOG_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/report-abuse", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/report-abuse">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Spam.svg")}
              />
            </span>
            <span className="menu-text">{REPORT_ABUSES_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/faqs", false)} d-none`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/faqs">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")}
              />
            </span>
            <span className="menu-text">{SETTINGS_CAP}</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
